// extracted by mini-css-extract-plugin
module.exports = {"hidden":"_6444e049b8--hidden--RE5_x","heading":"_6444e049b8--heading--GdAGQ","banners-container":"_6444e049b8--banners-container--KZ3Wi","banner":"_6444e049b8--banner--kg2jN"};